export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const MODAL_CLOSE_SEC = 2.5;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = '9b4bc239-b8b7-427d-869e-8e2188b25ee7';
